import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import { useForm, type DefaultValues, type FieldValues, type Path } from 'react-hook-form';
import type { ZodSchema } from 'zod';

type UseZodFormOptions<TData extends FieldValues> = {
  schema: ZodSchema<TData>;
  defaultValues?: DefaultValues<TData>;
  serverErrors?: Record<string, string>;
};

export function useZodForm<TData extends FieldValues>({
  schema,
  defaultValues,
  serverErrors,
}: UseZodFormOptions<TData>) {
  const form = useForm<TData>({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolver: zodResolver(schema as any),
    defaultValues,
    mode: 'onSubmit',
    reValidateMode: 'onChange',
  });

  useEffect(() => {
    if (serverErrors) {
      Object.entries(serverErrors).forEach(([field, message]) => {
        form.setError(field as Path<TData>, {
          type: 'server',
          message,
        });
      });
    }
  }, [serverErrors, form]);

  return form;
}
